import type { OrderTicket as GQLOrderTicket } from '../generated/checkout.graphql';
import * as ItemBreakdown from './ShoppingCartItemPriceBreakdown';
import { take } from '../util/takePayload';

export type OrderTicket = {
  name: string;
  /**
   * The ticket blueprint this row was sold from — GA4's `item_id`, and the key that
   * joins a purchase back to the `view_item` and `add_to_cart` hits for the same
   * ticket. Non-null on the schema, optional here so an order summary from a server
   * that predates the field degrades to named item rows rather than failing.
   */
  blueprintId?: number;
  seat?: string;
  table?: string;
  discountCode?: string;
  breakdown?: ItemBreakdown.ItemBreakdown;
  token?: string;
  paperTicketHtml?: string;
};

export const fromGql = (gqlItem: GQLOrderTicket): OrderTicket => ({
  ...take<OrderTicket, GQLOrderTicket>(gqlItem, 'name', 'blueprintId', 'seat', 'table', 'discountCode', 'token', 'paperTicketHtml'),
  breakdown: gqlItem.breakdown ? ItemBreakdown.fromGql(gqlItem.breakdown) : undefined,
});
